import { AfterContentChecked, AfterContentInit, AfterViewChecked, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiMacroactivityService } from '../../shared/services/api-macroactivity.service';
import { ApiProjectTypeService } from '../../shared/services/api-project-type.service';
import { StepperServiceService } from '../../shared/services/stepper-service.service';
import { AddItemBackofficeDialogComponent } from '../add-item-backoffice-dialog/add-item-backoffice-dialog.component';
import { RemoveDialogComponent } from '../remove-dialog/remove-dialog.component';
import { LanguageService } from '../../shared/services/language.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { AuthService } from '../../shared/services/auth.service';
import { MetodologyDialogComponent } from '../metodology-dialog/metodology-dialog.component';
import { MacrosDialogComponent } from '../macros-dialog/macros-dialog.component';
import { SubTitle } from 'chart.js';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { Profile } from 'src/app/models/Profile';
import { Permission } from '../../shared/security/permission';


@Component({
  standalone: false,
  selector: 'app-macroactivity',
  templateUrl: './macroactivity.component.html',
  styleUrls: ['./macroactivity.component.css']
})
export class MacroactivityComponent implements OnInit {

  Permission = Permission;

  variables: any;
  arr1: any = [];
  arr2: any = [];
  // Form and sub form, needed to link parent form with this component form.
  form: any;
  @Input() canEditCatalog: boolean = false;
  subForm: any;
  private sub: Subscription | undefined = undefined;
  tecnologia: any; //Which technology is being created or edited.

  @Input() listItem: any = [] //List of macro activities choosen by the user.
  @Input() profiles: Profile[] = [];
  listFilteredItem: any = [];

  preDefinedValues: any[] = [];

  currentSelectedType: any = '';
  oldSelectedType: any;
  currentElement: any;

  isActionsListVisible: boolean = false;

  currentIndex: number = 0;


  preDefinedMethodologyTypes: any[] = []; //Predefined list of methodology types
  alreadyInMethodologyDB: any[] = []; //List of methodologies types already in db
  alreadyInMacroDB: any[] = []; //List of macro types already in db
  centers: string[] = [];



  constructor(private _formBuilder: FormBuilder,
    private ctrlContainer: FormGroupDirective,
    private stepperService: StepperServiceService,
    public dialog: MatDialog,
    public authService: AuthService,
    private route: ActivatedRoute,
    private macroActivityService: ApiMacroactivityService,
    private languageService: LanguageService,
    private _snackBar: MatSnackBar,
    private UsersManagementService: UsersManagementService,
    private techService: TecnologiasService,
    private infoBar: InfoBarWithStatusService,
  ) { }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.sub = this.stepperService.dataChange.subscribe((data: any) => {
      this.tecnologia = data;
    });

    //Link sub form and form
    this.subForm = this._formBuilder.group({
      projectType: [''],
    });

    this.form = this.ctrlContainer.form;
    this.form.addControl("formGroup5", this.subForm);
    this.subForm.status = "INVALID";
    this.form.status = "INVALID";
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.variables) {
      this.preDefinedMethodologyTypes = [];
      this.preDefinedMethodologyTypes.push(
        {
          method: this.variables.waterfall,
          macro:
            [
              { "name": this.variables.requirementsGather, value: 18 },
              { "name": this.variables.requirementsAnalysis, value: 8 },
              { "name": this.variables.technicalDrawingArchitecture, value: 15 },
              { "name": this.variables.integratedSystemTests, value: 15 },
              { "name": this.variables.acceptanctTestsAdjustments, value: 8 },
              { "name": this.variables.implantation, value: 8 },
              { "name": this.variables.projectManagement, value: 15 },
              { "name": this.variables.other, value: 0 },
            ]
        },
        {
          method: this.variables.agile,
          macro:
            [
              { "name": this.variables.planning, value: 8 },
              { "name": this.variables.integratedSystemTests, value: 15 },
              { "name": this.variables.reviewRetrospective, value: 8 },
              { "name": this.variables.backlogRefinement, value: 8 },
              { "name": this.variables.scrumMaster, value: 15 },
              { "name": this.variables.other, value: 0 },
            ]
        },
        {
          method: this.variables.other,
          macro: [
            { "name": this.variables.other, value: 0 }
          ],
        }
      )
    }

    if (changes.listItem?.currentValue)
     this.alreadyInMethodologyDB = changes.listItem.currentValue
  }

  onChange(event: any) {
  }

  addMethodologyDialog() {
    var arrAll;
    this.arr1 = [];
    this.arr2 = [];
    arrAll = this.listItem;

    for (var i = 0; i < arrAll.length; i++) {
      !this.arr1.includes(arrAll[i].type) && this.arr1.push(arrAll[i].type);
      if (arrAll[i].type == this.currentSelectedType) {
        !this.arr2.includes(arrAll[i].name) && this.arr2.push(arrAll[i].name);
      }
    }

    // Prepare data to be passed to dialog component
    let data = {};

    data = {
      title: this.variables.addNewMetodology,
      list: this.preDefinedMethodologyTypes,
      listInDB: this.listItem,
      effort: "%",
      isActionType: false,
      isMacroActivities: true,
      isMetodology: true,
      isEdit: false,
      profiles: this.profiles,
      centers: this.centers,
    }

    let dialogRef = this.dialog.open(MetodologyDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      //Add item to array
      if (result) {

        if (result.data.isMetodology) {

          const macroA = {
            "metodology": result.data.name,
            "macroActivities":
              [
/*                {
                  "name": result.data.macroActivities,
                  "effort": result.data.effort.toFixed("2"),
                  "maxHours": result.data.maxHours || null,
                  "profileId": result.data.profileId || null,
                  "centers": result.data.centers ,
                }
*/
              ]
          }
          this.listItem.push(macroA);
          //this.listItemTypes.push(macroA.type);
          //this.showActionsList(macroA.macroActivities[0].name);
        }
      }
    })
  }

  editMethodologyDialog(item: any) {
    var arrAll;
    this.arr1 = [];
    arrAll = this.listItem;

    for (var i = 0; i < arrAll.length; i++) {
      this.arr1.push(arrAll[i].type);
    }

    const index = this.arr1.indexOf(item.name);
    if (index !== -1) {
      this.arr1.splice(index, 1);
    } else {
    }

    //Prepare data to be passed to dialog component
    const title = this.variables.editMacroType + ': ' + item.metodology

    const data = {
      title: title,
      type: 'edit',
      item: item,
      list: this.preDefinedMethodologyTypes,
      listInDB: this.listItem,
      isActionType: false,
      isMacroActivitiesType: true,
      isMacroActivities: true,
      isEdit: true,
      profiles: this.profiles,
    }

    let dialogRef = this.dialog.open(MetodologyDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {

      // Get result and update item on the arr
      if (result?.data) {

        this.listItem.forEach((v: any) => {
          if (v.metodology === result.data.item.metodology) {
            v.metodology = result.data.name;
          }
        })

        this.infoBar.showSnackbar(this.variables.methodEditedSuccessfully, ['successful-snackbar'], 4000);

      }

    })
  }


  addMacroDialog() {
    var arrAll;
    this.arr1 = [];
    this.arr2 = [];
    arrAll = this.listItem;

    for (var i = 0; i < arrAll.length; i++) {
      !this.arr1.includes(arrAll[i].type) && this.arr1.push(arrAll[i].type);
      if (arrAll[i].type == this.currentSelectedType) {
        !this.arr2.includes(arrAll[i].name) && this.arr2.push(arrAll[i].name);
      }
    }

    // Prepare data to be passed to dialog component
    let data = {};


    data = {
      title: this.variables.addNewMacro,
      metodology: this.currentSelectedType,
      list: this.preDefinedMethodologyTypes,
      listInDB: this.listItem,
      effort: "%",
      isMacroActivities: true,
      isMacroActivitiesType: false,
      isActionType: false,
      isMetodology: false,
      isEdit: false,
      profiles: this.profiles,
    }
    let dialogRef = this.dialog.open(MacrosDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      //Add item to array
      if (result) {

        if (this.arr2.includes(result.data.macro)) {
          this._snackBar.open(this.variables.snackBarErrorAddMacro);
        }
        else {
          const macroA =
          {
            "name": result.data.macroActivities,
            "effort": result.data.effort.toFixed("2"),
            "maxHours": result.data.maxHours || null,
            "profileId": result.data.profileId || null,
          }

          for (const key in this.listItem) {
            if (this.listItem[key].metodology === this.currentSelectedType) {
              this.listItem[key].macroActivities.push(macroA);
            }
          }

          this.showActionsList(result.data.metodology);
        }
      }
    })
  }

  editMacroDialog(item: any) {

    var arrAll;
    this.arr1 = [];
    arrAll = this.listItem;

    for (var i = 0; i < arrAll.length; i++) {
      if (arrAll[i].type == item.type) {
        this.arr1.push(arrAll[i].name);
      }
    }

    var index = this.arr1.indexOf(item.name);
    if (index !== -1) {
      this.arr1.splice(index, 1);
    }

    const data = {
      title: this.variables.editMacroActivity + ":",
      SubTitle: item.name,
      list: this.preDefinedMethodologyTypes,
      listInDB: this.listItem,
      metodology: this.currentSelectedType,
      item: item,
      effort: "%",
      isActionType: false,
      isMacroActivitiesType: false,
      isMacroActivities: true,
      isEdit: true,
      profiles: this.profiles,
    }


    let dialogRef = this.dialog.open(MacrosDialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {


      // Get result and update item on the arr
      if (result?.data) {

        const currentMethod: any = Object.values(this.listItem).find(
          (project: any) => project.metodology === this.currentSelectedType
        );

        if (currentMethod) {
          const activity = currentMethod.macroActivities.find(
            (act: any) => act.name === item.name
          );

          if (activity) {
            activity.name = result.data.macroActivities;
            activity.effort = result.data.effort.toFixed("2");
            activity.maxHours = result.data.maxHours || null;
            activity.profileId = result.data.profileId || null;


            this.infoBar.showSnackbar(this.variables.macroEditedSuccessfully, ['successful-snackbar'], 4000);

          }
        }
      }

    })
  }

  openDialogRemoveMacro(method: any) {

    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      // Remove item
      if (result === 'true') {

        this.listItem[this.currentIndex].macroActivities = this.listItem[this.currentIndex].macroActivities.filter((item: any) => item.name != method.name)
        this.showActionsList(this.currentSelectedType)

        this.infoBar.showSnackbar(this.variables.macroRemovedSuccessfully, ['successful-snackbar'], 4000);

      }

    });
  }

  openDialogRemoveType(method: any) {
    let dialogRef = this.dialog.open(RemoveDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      // Remove item
      if (result === 'true') {

        this.listItem = this.listItem.filter((item: any) => item !== method);

        this.isActionsListVisible = false;


        this.infoBar.showSnackbar(this.variables.methodRemovedSuccessfully, ['successful-snackbar'], 4000);

      }
    });
  }


  showActionsList(actionType: string) {
    if (!this.isActionsListVisible)
      this.isActionsListVisible = !this.isActionsListVisible;

    this.listFilteredItem = this.listItem.filter((item: any) => item.metodology === actionType);
    this.currentSelectedType = actionType;
    var oldElement = document.getElementById(this.oldSelectedType);
    oldElement?.classList.remove('type-checked')
    this.currentElement = document.getElementById(actionType);
    this.currentElement?.classList.add('type-checked')
    this.oldSelectedType = actionType;
  }

  highlightItem(actionType: any, index: number) {

    if (!this.isActionsListVisible) {
      this.isActionsListVisible = true;
    }

    this.listFilteredItem = this.listItem.filter((item: any) => item.metodology === actionType.metodology);
    this.currentSelectedType = actionType.metodology;

    // Remove class from old element if exists
    if (this.oldSelectedType !== undefined) {
      const oldElement = document.getElementById('item-' + this.oldSelectedType);
      oldElement?.classList.remove('type-checked');
    }

    // Add class to current element
    this.currentElement = document.getElementById('item-' + index);
    this.currentElement?.classList.add('type-checked');
    this.currentIndex = index

    this.oldSelectedType = index; // Store index for later
  }

  getProfileName(profileId: string): string {
    if (!profileId) return '-';
    const profile = this.profiles.find(p => p.id === profileId);
    return profile ? profile.name : '-';
  }

}
